import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import EmptyStateCard from "../Common/EmptyStateCard";

const OrdersEmptyState = () => {
    const { t } = useTranslation();

    return (
        <EmptyStateCard
            title={t("GIFT_ORDERS_EMPTY_TITLE")}
            description={t("GIFT_ORDERS_EMPTY_DESCRIPTION")}
            className="mt-12 px-6 py-16 text-center"
            actionSlot={(
                <Link
                    to="/product-collections"
                    className="btn-primary mt-6 w-full sm:w-auto"
                >
                    {t("GIFT_ORDERS_EMPTY_ACTION")}
                </Link>
            )}
        />
    );
};

export default OrdersEmptyState;
